/*** IMPORTS FROM imports-loader ***/
var define = false;

// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/identity.js
// module id = 35
// module chunks = 0